import React, { useEffect } from 'react'
import HeaderSec from '../../HeaderSec/HeaderSec'
import FooterSecComp from '../FooterSecComp'
import { Typography } from '@mui/material'
import FooterComp from '../FooterComp'
import support from '../../../Assets/img/Support GuideStarIndia.png'


const Support = () => {
    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

    const section1 = [
        'Namaste! ',
        'When you support GuideStar India, you are playing a role in transforming India’s social sector. Your contribution helps us build trust in Not-for-Profit organisations through greater transparency across their governance, programmes, operations, and financial reporting. Any contribution in the form of a donation or grant would help us. You could choose to support our mission or to support our specific programmes for NPOs working in your preferred geography/ thematic area.',

    ]
    const section2 = [
        'We do not solicit donations through phone calls or through door-to-door visits. We do not accept donations in cash. We do not collect donations on behalf of other NPOs/NGOs. '
    ]

  return (
    <div className='max-w-screen overflow-hidden text-black'>
        <HeaderSec/>
        <div className='max-w-[1200px] m-auto min-h-[500px]'>
            <FooterSecComp
                topic={"SUPPORT GUIDESTAR INDIA"}
                section={section1}
                image={support}
            />
            <Typography
              variant='h3'
              sx={{
                fontSize: '15px',
                fontWeight: 400,
                margin: '0 0 10px 0',
                textAlign: 'justify',
                lineHeight: 1.6
              }}
            >
                Your contributions should be in favour of our public charitable trust <span className='font-bold'>Civil Society Information Services India</span>, a charity registered in the State of Delhi, with tax exemption under section 12A of the Indian Income Tax Act. Indian taxpayers can get an 80G tax deduction certificate on providing details as required under the Income Tax Act. We are also eligible to receive foreign contributions as per the FCRA.   
            </Typography>
            <Typography variant='h3'  sx={{fontSize:'15px' , fontWeight:400 , margin:' 0 0 10px 0' , textAlign:'justify' , lineHeight:1.6}}>
                Write to us at <a href="mailto:info@guidestarindia.org" className='text-blue-600'>info@guidestarindia.org</a>  and we will be happy to respond to your offer, your specific questions (if any) and share our bank account details! Thank you for your desire to make a big difference!
            </Typography>
            <FooterSecComp
                pointHead={"Please note: "}
                section={section2}
            />
        </div>

        <FooterComp/>
    </div>
  )
}

export default Support